import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
// import PrintExport from "../../../components/common/ui/Export/PrintExport";
import {
  CheckBoxInput,
  TextAreaInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import { useReactToPrint } from "react-to-print";
import { history } from "../../../_helpers";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  facilityAction,
  masterActions,
  staffRequestAction,
  authActions,
} from "../../../_store";
import CustomLoader from "../../../components/common/ui/Loader";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import FormHeader from "./FormHeader";
import {
  MenuItem,
  StoredProcedures,
  SubMenuItem,
  UserRoleType,
} from "../../../_helpers/enumerator";
import {
  formatDateTimeAMPM,
  formatDateTimeAMPMWith24,
  // getCurrentDate,
} from "../../../utils/formatTime";
import { handleReviewRequestFormNavigation } from "./ReviewRequestFormNavigator";

function RequestRemedyForm() {
  const componentRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const staffRequestID = parseInt(process.env.REACT_APP_STAFF_REQUEST_ACCESSIBLE_FA, 10);
  const STAFF_REQUEST_ACCESSIBLE_FA = [staffRequestID];

  const formID = location?.state ? location?.state?.formID : 0;

  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  const formDetails = location?.state ? location?.state?.formDetails : {};

  const { user } = useSelector((x) => x.auth);
  const managementUserID = user?.ManagementUserID;
  const userRoleID = user?.UserRoleID;
  const loggedUserName = user?.UserName;
  const {
    InitialremedyRequestFormData,
    remedyRequestFormData,
    submitRemedyRequestFormResponse,
    requestReview,
    // staffRequestList,
    // GetManagementUserAccessPermissionResponse,
    legalRequestFormAccess: requestRemedyFormAccess,
    indexValue,
    staffRequestSearchList,
    staffRequestList,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const [errorMessage, setErrorMessage] = useState({});

  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);

  // const [facilityName, setFacilityName] = useState("");

  const [showBtn, setShowBtn] = useState(true);

  const prevFacilityCodeRef = useRef(facilityCode);

  const [submittedFormList, setSubmittedFormList] = useState([]);

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
    // .then((data) => {
    //   const facilityList = data?.payload;
    //   const facilityName = facilityList?.find(
    //     (x) => x?.value === facilityCode
    //   )?.label;
    //   // setFacilityName(facilityName);
    // })
    // .catch(() => {
    //   // setFacilityName("");
    // });
  }, []);

  useEffect(() => {
    if (
      userRoleID === 1 ||
      STAFF_REQUEST_ACCESSIBLE_FA?.includes(managementUserID)
    ) {
      setShowBtn(true);
      return;
    } else {
      dispatch(
        staffRequestAction?.GetManagementUserAccessPermission({
          ManagementUserID: managementUserID,
          ManagementMenuID: MenuItem?.RequestsOrGrievancesMenuItem,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (
            data?.length > 0 &&
            data?.[1]?.SubMenuID === SubMenuItem?.RespondSubMenuItem &&
            data?.[1]?.SubMenuActiveStatus === 1 &&
            data?.[0]?.RequestCurrentStatus !== "Closed"
          ) {
            setShowBtn(true);
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get Access data", "error");
        });
    }
  }, []);

  useEffect(() => {
    if (RequestFormType > 0) {
      dispatch(
        staffRequestAction?.getRequestFormAccess({
          ManagementUserID: managementUserID,
          formID:
            RequestFormType > 0
              ? RequestFormType
              : formDetails?.DataList?.[indexValue]?.RequestFormType,
          FacilityCode: facilityCode,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (
            data?.FormRespond === 0 &&
            userRoleID === UserRoleType?.InvestigatorsStaff
          ) {
            setShowBtn(false);
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get permission data", "error");
        });
    }
  }, [
    RequestFormType,
    dispatch,
    facilityCode,
    formDetails?.DataList,
    indexValue,
    managementUserID,
    userRoleID,
  ]);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate(sourceFrom);
    }
  }, [facilityCode]);

  useEffect(() => {
    // if (formID === 0) history?.navigate("/Admin/StaffRequestList");
    if (formID > 0) {
      dispatch(staffRequestAction?.getRemedyRequestFormData(formID));
      if (facilityCode) {
        dispatch(
          facilityAction?.GetFacilityStaffReqInfo({ facilityID: facilityCode })
        );
      }
    }
    else {
      history?.navigate("/Admin/StaffRequestList");
    }
  }, [indexValue, formID]);

  useEffect(() => {
    switch (submitRemedyRequestFormResponse?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: facilityCode ? facilityCode : 0,
            ProcedureName: StoredProcedures?.RequestAdminRemedyRespond,
            UserAction: `Changed Form Type ( RequestAdminRemedyID - ${formID} )`,
          })
        );
        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID: RequestFormType,
            facilityID: facilityCode,
            createdBy: managementUserID,
          })
        );
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: managementUserID,
            FacilityID: facilityCode,
          })
        );
        showToastNotification("Remedy form submitted successfully", "success");
        if (!requestReview) {
          // const searchList = {
          //   ...staffRequestSearchList,
          //   PageNo: 1,
          //   RowCountPerPage: 10,
          //   FacilityID: facilityCode,
          // };
          dispatch(
            staffRequestAction?.setStaffRequestSearchList(
              staffRequestSearchList
            )
          );
          history?.navigate("/Admin/StaffRequestList");
        }
        const formList = [...submittedFormList];
        formList.push(formID);
        setSubmittedFormList(formList);

        if (requestReview) {
          //admin
          const searchData = { ...staffRequestSearchList };
          searchData.PageNo = 1;
          searchData.RowCountPerPage = staffRequestList?.TotalRecordCount;
          searchData.FacilityID = facilityCode;
          searchData.ManagementUserID = managementUserID;
          dispatch(staffRequestAction?.LoadRequestReviewAllList(searchData))
            .then((result) => {
              if (result?.payload?.DataList?.length > 0) {
                const data = result?.payload;
                handleReviewRequestFormNavigation(
                  "next",
                  data,
                  indexValue,
                  history,
                  sourceFrom,
                  dispatch
                );
              } else {
                history?.navigate("/Admin/StaffRequestList");
              }
            })
            .catch((err) => {
              showToastNotification(err?.message, "error");
            });
        }

        dispatch(staffRequestAction?.resetForm());
        break;

      case -2:
        showToastNotification("Not Exist", "error");
        history?.navigate("/Admin/StaffRequestList");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [submitRemedyRequestFormResponse]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,

    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;
    const grievanceData = { ...remedyRequestFormData };
    if (type === "checkbox") {
      grievanceData[name] = checked ? 1 : 0;
    } else {
      grievanceData[name] = value;
    }

    dispatch(staffRequestAction?.updateGrievanceData(grievanceData));
  };

  const handleFormSubmit = (e) => {
    if (requestRemedyFormAccess?.FormRespond === 0) return;
    e?.preventDefault();
    const payloadData = { ...remedyRequestFormData };
    payloadData.FacilityID = facilityCode;
    payloadData.GrievanceReceivedBy = managementUserID;
    payloadData.ManagementUserID = managementUserID;
    payloadData.SignatureDate = payloadData.SignatureDate
      ? payloadData.SignatureDate
      : formatDateTimeAMPM(new Date());
    payloadData.GrievanceReceivedDate = payloadData.GrievanceReceivedDate
      ? payloadData.GrievanceReceivedDate
      : formatDateTimeAMPM(new Date());
    payloadData.InvestigationCompletedBy = managementUserID;
    dispatch(staffRequestAction?.submitRemedyRequestForm(payloadData));
  };

  const handleReset = () => {

    const grievanceData = { ...remedyRequestFormData };

    if (InitialremedyRequestFormData) {
      grievanceData.InvestigationBody =
        InitialremedyRequestFormData?.InvestigationBody;
      grievanceData.ReviewFindingsBody =
        InitialremedyRequestFormData?.ReviewFindingsBody;
      grievanceData.SupervisorSignature =
        InitialremedyRequestFormData?.SupervisorSignature;
      grievanceData.SupervisorTitle =
        InitialremedyRequestFormData?.SupervisorTitle;
      grievanceData.GrievanceForward =
        InitialremedyRequestFormData?.GrievanceForward;
      dispatch(staffRequestAction?.updateGrievanceData(grievanceData));
      return;
    }
    if (requestRemedyFormAccess?.FormRespond === 0) return;

    grievanceData.InvestigationBody = "";
    grievanceData.ReviewFindingsBody = "";
    grievanceData.SupervisorSignature = "";
    grievanceData.SupervisorTitle = "";
    grievanceData.GrievanceForward = 0;
    dispatch(staffRequestAction?.updateGrievanceData(grievanceData));
  };


  return (
    <>
      {loading || facilityLoader && <CustomLoader />}
      <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        <FormHeader
          list={formDetails}
          requestReview={requestReview}
          handlePrints={handlePrints}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />

        <div className="">
          <form>
            <div ref={componentRef}>
              <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                <div className="d-flex req-header-img">
                  {GetFacilityStaffReqInfoResponse?.LogoFile && (
                    <img
                      src={
                        "data:image/png;base64," +
                        GetFacilityStaffReqInfoResponse?.LogoFile
                      }
                      alt="facility-logo"
                      className="req-img"
                    />
                  )}
                </div>
                <div className="justify-content-center align-items-center req-header-title">
                  <h3 className="text-color py-2 text-center">
                    <span className="label-red req-text">
                      {GetFacilityStaffReqInfoResponse?.FacilityName?.toUpperCase()}
                    </span>
                  </h3>
                </div>
              </div>
              <h4
                className="request-form-header text-color mt-4"
                style={{ cursor: "pointer" }}
              >
                <i className="fa-solid fa-circle-info me-2"></i> REQUEST REMEDY
                FORM
              </h4>

              <div className="m-1 row border-bottom-1 request-form-card details-legal">
                <h4
                  className="request-form-header text-color mt-4"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa-solid fa-user me-2"></i> INMATE INFORMATION
                </h4>
                {[
                  {
                    label: "Name",
                    value: remedyRequestFormData?.InmateFullName,
                  },
                  {
                    label: "ID",
                    value: remedyRequestFormData?.InmateResidentId,
                  },
                  {
                    label: "Date",
                    value: remedyRequestFormData?.RequestCreateDate,
                  },
                  { label: "POD", value: remedyRequestFormData?.PodCode },
                ].map((item, index) => (
                  <div key={index} className="col-sm-12 col-md-6 col-lg-6">
                    <div className="user-information d-flex flex-wrap align-items-center">
                      <div className="fs-5 p-2  value-info">{item.label}</div>
                      <div className="p-1">:</div>
                      <div className="fs-5 p-2 text-start fw-bold value-text">
                        {item.value || "-"}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <h4
                className="inner-header-bg text-color mt-3"
                style={{ cursor: "pointer" }}
              >
                <i className="fa-solid fa-circle-info me-2"></i> GRIEVANCE INFO
              </h4>

              <div className="row mt-1 border-0">
                <div className="col-md-4">
                  <span className=" fs-5 request-form-label">Grievance</span>
                </div>
                <div className="col-md-8">
                  <div className="d-flex flex-wrap gap-3">
                    <CheckBoxInput
                      label="Original"
                      checked={remedyRequestFormData?.GrvOriginal === 1}
                      disabled
                    />
                    <CheckBoxInput
                      label="Appeal"
                      checked={remedyRequestFormData?.GrvAppeal === 1}
                      disabled
                    />
                    <CheckBoxInput
                      label="Disciplinary Action Appeal"
                      checked={
                        remedyRequestFormData?.GrvDisciplinaryActionAppeal === 1
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="row mt-3 border-0">
                  <span className=" col-md-4 fs-5 request-form-label">
                    Description
                  </span>
                  <div className="col-md-8">
                    <TextAreaInput
                      value={remedyRequestFormData?.GrievanceBody}
                      disabled
                      rows={2}
                    />
                  </div>
                </div>

                <div className="row mt-3 border-0">
                  <span className="col-md-4 fs-5 mb-0 request-form-label">
                    Received By
                  </span>
                  <div className="col-md-8">
                    <TextInput
                      // value={
                      //   remedyRequestFormData?.GrievanceReceivedUser
                      //     ? remedyRequestFormData?.GrievanceReceivedUser
                      //     : managementUserID
                      // }
                      value={
                        ((userRoleID === 1 || userRoleID === 2 || userRoleID == 12) &&
                          remedyRequestFormData?.GrievanceReceivedUserFullName != null &&
                          remedyRequestFormData?.GrievanceReceivedUserFullName !== "  ")
                          ? remedyRequestFormData?.GrievanceReceivedUserFullName
                          : (remedyRequestFormData?.GrievanceReceivedUser != null &&
                            remedyRequestFormData?.GrievanceReceivedUser !== '')
                            ? remedyRequestFormData?.GrievanceReceivedUser
                            : loggedUserName
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="row mt-3 border-0">
                  <span className="col-md-4 fs-5 mb-0 request-form-label">
                    Date Received
                  </span>
                  <div className="col-md-8">
                    <TextInput
                      value={
                        remedyRequestFormData?.GrievanceReceivedDate
                          ? remedyRequestFormData?.GrievanceReceivedDate
                          : formatDateTimeAMPMWith24(new Date())
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-8 mt-3 d-flex flex-wrap border-0">
                  <span className="fs-5 mb-0 request-form-label"></span>
                  <CheckBoxInput
                    label={"Forwarded"}
                    name="GrievanceForward"
                    id="GrievanceForward"
                    checked={remedyRequestFormData?.GrievanceForward}
                    handleClick={(e) => handleChange(e)}
                    disabled={requestRemedyFormAccess?.FormRespond === 0}
                  />
                </div>
              </div>

              <h4
                className="inner-header-bg text-color"
                style={{ cursor: "pointer" }}
              >
                <i className="fa-solid fa-circle-info me-2"></i> INVESTIGATION
                INFO
              </h4>

              <div className="row mt-1 border-0">
                <div className="row mt-3 border-0">
                  <span className=" col-md-4 fs-5 request-form-label">
                    Investigation
                  </span>
                  <div className="col-md-8">
                    <TextAreaInput
                      rows={3}
                      name="InvestigationBody"
                      placeholder={"Enter Investigation"}
                      cName={"w-100"}
                      value={remedyRequestFormData?.InvestigationBody}
                      handleChange={(e) => handleChange(e)}
                      disabled={
                        // remedyRequestFormData?.RequestCurrentStatus ===
                        //   "Closed" &&

                        requestRemedyFormAccess?.FormRespond === 0
                      }
                      maxLength={2000}
                    />
                  </div>
                </div>

                <div className="row mt-3 border-0">
                  <span className="col-md-4 fs-5 mb-0 request-form-label">
                    Completed By
                  </span>
                  <div className="col-md-8">
                    <TextInput
                      value={
                        ((userRoleID === 1 || userRoleID === 2 || userRoleID == 12) &&
                          remedyRequestFormData?.InvestigationCompletedByMUUserFullName != null &&
                          remedyRequestFormData?.InvestigationCompletedByMUUserFullName !== "  ")
                          ? remedyRequestFormData?.InvestigationCompletedByMUUserFullName
                          : (remedyRequestFormData?.InvestigationCompletedByUser != null &&
                            remedyRequestFormData?.InvestigationCompletedByUser !== "  ")
                            ? remedyRequestFormData?.InvestigationCompletedByUser
                            : loggedUserName
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>

              <h4
                className="inner-header-bg text-color"
                style={{ cursor: "pointer" }}
              >
                <i className="fa-solid fa-circle-info me-2"></i> REVIEW FINDINGS
                INFO
              </h4>
              <div className="row mt-1 border-0">
                <div className="row mt-3">
                  <div className="col-md-4">
                    <span className=" fs-5 request-form-label">
                      Review Findings
                    </span>
                  </div>
                  <div className="col-md-8">
                    <TextAreaInput
                      rows={3}
                      name="ReviewFindingsBody"
                      placeholder={"Enter Review"}
                      cName={"w-100"}
                      value={remedyRequestFormData?.ReviewFindingsBody}
                      handleChange={(e) => handleChange(e)}
                      disabled={
                        // remedyRequestFormData?.RequestCurrentStatus ===
                        //   "Closed" &&

                        requestRemedyFormAccess?.FormRespond === 0
                      }
                      maxLength={2000}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <span className=" col-md-4 fs-5 mb-0 request-form-label">
                    Date
                  </span>
                  <div className="col-md-8">
                    <TextInput
                      value={
                        remedyRequestFormData?.SignatureDate
                          ? remedyRequestFormData?.SignatureDate
                          : formatDateTimeAMPMWith24(new Date())
                      }
                      disabled
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <span className="col-md-4 fs-5 mb-0 request-form-label">
                    Supervisor Signature
                  </span>
                  <div className="col-md-8">
                    <TextInput
                      name="SupervisorSignature"
                      placeholder="Signature"
                      value={remedyRequestFormData?.SupervisorSignature}
                      handleChange={(e) => handleChange(e)}
                      maxLength={100}
                      disabled={
                        // remedyRequestFormData?.RequestCurrentStatus ===
                        //   "Closed" &&

                        requestRemedyFormAccess?.FormRespond === 0
                      }
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <span className="col-md-4 fs-5 mb-0 request-form-label">
                    Title
                  </span>
                  <div className="col-md-8">
                    <TextInput
                      name="SupervisorTitle"
                      placeholder="Title"
                      value={remedyRequestFormData?.SupervisorTitle}
                      handleChange={(e) => handleChange(e)}
                      maxLength={50}
                      disabled={
                        // remedyRequestFormData?.RequestCurrentStatus ===
                        //   "Closed" &&

                        requestRemedyFormAccess?.FormRespond === 0
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* {showBtn &&
              requestRemedyFormAccess &&
              requestRemedyFormAccess?.FormRespond === 1 && ( */}
            {showBtn && !submittedFormList?.includes(formID) && (
              <div className="mt-4 pb-3 gap-3 d-flex flex-wrap justify-content-center align-items-center">
                <Button
                  label="Submit"
                  status="success"
                  icon="fa-solid fa-floppy-disk"
                  type="button"
                  onClick={(e) => handleFormSubmit(e)}
                  disabled={requestRemedyFormAccess?.FormRespond === 0}
                />
                <Button
                  label="Reset"
                  status="secondary"
                  type="button"
                  icon="fa-solid fa-rotate-right"
                  onClick={handleReset}
                  disabled={requestRemedyFormAccess?.FormRespond === 0}
                />
              </div>
            )}

            {/* )} */}
          </form>
        </div>
      </div>
    </>
  );
}

export default React.memo(RequestRemedyForm);
